import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.tsx";
import { UpdatePrompt } from "./components/UpdatePrompt.tsx";
import "./styles.css";

const container = document.getElementById("root");
if (!container) throw new Error("No se encontro #root");

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
      <UpdatePrompt />
    </BrowserRouter>
  </StrictMode>,
);
